import { ViewModel } from 'view_models/view_model'
import { Address } from 'entities/address'

export class AddressViewModel extends ViewModel<Address> {
    public wholeView = (options?: { isBuildingLineBreak?: boolean; zipCodeSize?: number; maxWidth?: number }): JSX.Element => {
        return (
            <div style={{ maxWidth: options?.maxWidth }}>
                <div style={{ fontSize: options?.zipCodeSize || 11 }}>〒 {this.zipCode()}</div>
                <div style={{ wordBreak: 'break-all' }}>
                    {this.object.prefecture} {this.object.city} {this.object.line}
                    {options?.isBuildingLineBreak ? <br /> : ' '}
                    {this.object.building || ''}
                </div>
            </div>
        )
    }

    public whole = (options?: { isBuildingLineBreak?: boolean; showZipCode?: boolean }): string => {
        return `${options?.showZipCode ? `〒${this.zipCode()} ` : ' '}${this.object.prefecture} ${this.object.city} ${this.object.line || ''}${
            options?.isBuildingLineBreak ? '\n' : ' '
        }${this.object.building || ''}`
    }

    public zipCode = () => {
        if (this.object.zipCode?.includes('-')) {
            return this.object.zipCode
        } else {
            return this.object.zipCode?.slice(0, 3) + '-' + this.object.zipCode?.slice(3)
        }
    }
    public readText = (): string => {
        return `郵便番号、${this.zipCode()}、${this.object.prefecture} ${this.object.city} ${this.object.line || ''} ${this.object.building || ''}`
    }
}
